import moment from "moment-timezone";

export function Timezone__Offset(timezone?: string, isoDate?: string) {
  let date = timezone ? moment(isoDate).tz(timezone) : moment(isoDate);
  return date.utcOffset();
}
